import {
  Component,
  forwardRef,
  HostListener,
  Input,
  OnInit,
  ElementRef,
  AfterContentChecked,
  EventEmitter,
} from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { ItemPipe } from './item.pipe';
import { SelectableItem } from './models/selectable-item';
import { SelectOption } from './models/select-option';
import { SelectService } from './select.service';
import { TreeSelectDefaultOptions } from './models/tree-select-default-options';

import { ChineseToPinyinService } from '../core/service/chineseToPinyin.service';

// tslint:disable-next-line:no-empty
const noop = () => { };
export const CUSTOM_INPUT_CONTROL_VALUE_ACCESSOR: any = {
  provide: NG_VALUE_ACCESSOR,
  // tslint:disable-next-line:no-forward-ref
  useExisting: forwardRef(() => TreeSelectComponent),
  multi: true
};

@Component({
  selector: 'ant-tree-select',
  template:`<span class="ant-select ant-select-enabled"
  [class.ant-select-open]="isOpen"
  [class.ant-select-focused]="isOpen" [ngStyle]="{'width': width + 'px'}"
  (blur)="onTouched()" (keyup)="keyUp($event)" [off-click]="clickedOutside">
<span class="ant-select-selection"
  [ngClass]="{'ant-select-selection--multiple': multiple === true, 'ant-select-selection--single': multiple === false}"
  (click)="toggle($event)">
  <ul class="ant-select-selection__rendered" *ngIf="selection.length > 0 && selection.length > 1">
    <li *ngFor="let s of selection; let i=index" class="ant-select-selection__choice" title="{{s.text}}" style="user-select: none;">
      <span class="ant-select-selection__choice__remove" (click)="removeItem($event, s)"></span>
      <span class="ant-select-selection__choice__content">{{s.text}}</span>
    </li>
  </ul>
<span class="ant-select-selection__rendered" *ngIf="selection.length > 0 && selection.length === 1">
    <span title="{{selection[0].text}}" class="ant-select-selection-selected-value">{{selection[0].text}}</span>
</span>
<span class="ant-select-selection__clear" (click)="clearAll($event)"></span>
<span *ngIf="multiple === false" class="ant-select-arrow" style="outline: none;"><b></b></span>
<span *ngIf="selection.length <= 0" class="ant-select-search__field__placeholder">{{placeholder}}</span>
</span>
<div *ngIf="!disabled && isOpen && internalItems && internalItems.length > 0"
  class="ant-select-dropdown ant-select-tree-dropdown ant-select-dropdown--multiple ant-select-dropdown-placement-bottomLeft"
  [ngClass]="{'ant-select-dropdown-hidden': isOpen === false}" style="overflow: auto;overflow-x:hidden" [ngStyle]="_style()">
  <div>
    <span class="ant-select-dropdown-search" *ngIf="allowFilter">
      <span class="ant-select-search__field__wrap">
        <input value="" class="ant-select-search__field" role="textbox"
          [(ngModel)]="filter" (click)="setInputFocus()" (blur)="setInputFocusOut()"
          placeholder="{{filterPlaceholder}}" [ngModelOptions]="{standalone: true}" >
      </span>
    </span>
    <ul class="ant-select-tree" role="tree-node" unselectable="true">
      <li *ngFor="let o of internalItems | itemPipe: filter">
        <ant-tree-select-item [item]="o" (TouchedCallBack)="onTouchedCallback"></ant-tree-select-item>
      </li>
    </ul>
  </div>
</div>
</span>
`,
  providers: [CUSTOM_INPUT_CONTROL_VALUE_ACCESSOR, SelectService, ChineseToPinyinService],
  styles: [`.ant-select {
  box-sizing: border-box;
  display: inline-block;
  position: relative;
  color: rgba(0, 0, 0, 0.65);
  font-size: 12px;
}
.ant-select > ul > li > a {
  padding: 0;
  background-color: #fff;
}
.ant-select-arrow {
  font-style: normal;
  vertical-align: baseline;
  text-align: center;
  text-transform: none;
  text-rendering: optimizeLegibility;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  position: absolute;
  top: 50%;
  right: 8px;
  line-height: 1;
  margin-top: -6px;
  display: inline-block;
  font-size: 12px;
  font-size: 9px \9;
  transform: scale(0.75) rotate(0deg);
  /* IE6-IE8 */
  -ms-filter: "progid:DXImageTransform.Microsoft.Matrix(sizingMethod='auto expand', M11=1, M12=0, M21=0, M22=1)";
  zoom: 1;
}
.ant-select-arrow:before {
  display: block;
  font-family: "anticon" !important;
}
:root .ant-select-arrow {
  filter: none;
}
:root .ant-select-arrow {
  font-size: 12px;
}
.ant-select-arrow * {
  display: none;
}
.ant-select-arrow:before {
  content: "\\e61d";
  transition: transform 0.2s ease;
}
.ant-select-selection {
  outline: none;
  user-select: none;
  box-sizing: border-box;
  display: block;
  background-color: #fff;
  border-radius: 4px;
  border: 1px solid #d9d9d9;
  transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
}
.ant-select-selection:hover {
  border-color: #49a9ee;
}
.ant-select-focused .ant-select-selection,
.ant-select-selection:focus,
.ant-select-selection:active {
  border-color: #49a9ee;
  outline: 0;
  box-shadow: 0 0 0 2px rgba(16, 142, 233, 0.2);
}
.ant-select-selection__clear {
  display: inline-block;
  font-style: normal;
  vertical-align: baseline;
  text-align: center;
  text-transform: none;
  text-rendering: auto;
  opacity: 0;
  position: absolute;
  right: 8px;
  z-index: 1;
  background: #fff;
  top: 50%;
  font-size: 12px;
  color: rgba(0, 0, 0, 0.25);
  width: 12px;
  height: 12px;
  margin-top: -6px;
  line-height: 12px;
  cursor: pointer;
  transition: color 0.3s ease, opacity 0.15s ease;
}
.ant-select-selection__clear:before {
  display: block;
  font-family: 'anticon';
  text-rendering: optimizeLegibility;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  content: "\\e62e";
}
.ant-select-selection__clear:hover {
  color: rgba(0, 0, 0, 0.43);
}
.ant-select-selection:hover .ant-select-selection__clear {
  opacity: 1;
}
.ant-select-selection-selected-value {
  float: left;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 100%;
  padding-right: 14px;
}
.ant-select-disabled {
  color: rgba(0, 0, 0, 0.25);
}
.ant-select-disabled .ant-select-selection {
  background: #f7f7f7;
  cursor: not-allowed;
}
.ant-select-disabled .ant-select-selection:hover,
.ant-select-disabled .ant-select-selection:focus,
.ant-select-disabled .ant-select-selection:active {
  border-color: #d9d9d9;
  box-shadow: none;
}
.ant-select-disabled .ant-select-selection__clear {
  display: none;
  visibility: hidden;
  pointer-events: none;
}
.ant-select-disabled .ant-select-selection--multiple .ant-select-selection__choice {
  background: #eee;
  color: #aaa;
  padding-right: 10px;
}
.ant-select-disabled .ant-select-selection--multiple .ant-select-selection__choice__remove {
  display: none;
}
.ant-select-selection--single {
  height: 28px;
  position: relative;
  cursor: pointer;
}
.ant-select-selection__rendered {
  display: block;
  margin-left: 7px;
  margin-right: 7px;
  position: relative;
  line-height: 26px;
}
.ant-select-selection__rendered:after {
  content: '.';
  visibility: hidden;
  pointer-events: none;
  display: inline-block;
  width: 0;
}
.ant-select-lg .ant-select-selection--single {
  height: 32px;
}
.ant-select-lg .ant-select-selection__rendered {
  line-height: 30px;
}
.ant-select-lg .ant-select-selection--multiple {
  min-height: 32px;
}
.ant-select-lg .ant-select-selection--multiple .ant-select-selection__rendered li {
  height: 24px;
  line-height: 24px;
}
.ant-select-lg .ant-select-selection--multiple .ant-select-selection__clear {
  top: 16px;
}
.ant-select-sm .ant-select-selection--single {
  height: 22px;
}
.ant-select-sm .ant-select-selection__rendered {
  line-height: 20px;
}
.ant-select-sm .ant-select-selection--multiple {
  min-height: 22px;
}
.ant-select-sm .ant-select-selection--multiple .ant-select-selection__rendered li {
  height: 14px;
  line-height: 14px;
}
.ant-select-sm .ant-select-selection--multiple .ant-select-selection__clear {
  top: 11px;
}
.ant-select-disabled .ant-select-selection__choice__remove {
  color: rgba(0, 0, 0, 0.25);
  cursor: default;
}
.ant-select-disabled .ant-select-selection__choice__remove:hover {
  color: rgba(0, 0, 0, 0.25);
}
.ant-select-search__field__wrap {
  display: inline-block;
  position: relative;
}
.ant-select-selection__placeholder,
.ant-select-search__field__placeholder {
  position: absolute;
  top: 50%;
  left: 0;
  right: 9px;
  color: rgba(0, 0, 0, 0.25);
  line-height: 20px;
  height: 20px;
  max-width: 100%;
  margin-top: -10px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  text-align: left;
}
.ant-select-search__field__placeholder {
  left: 8px;
}
.ant-select-search--inline {
  position: absolute;
  height: 100%;
  width: 100%;
}
.ant-select-selection--multiple .ant-select-search--inline {
  float: left;
  position: static;
}
.ant-select-search--inline .ant-select-search__field__wrap {
  width: 100%;
  height: 100%;
}
.ant-select-search--inline .ant-select-search__field {
  border-width: 0;
  font-size: 100%;
  height: 100%;
  width: 100%;
  background: transparent;
  outline: 0;
  border-radius: 4px;
}
.ant-select-search--inline .ant-select-search__field__mirror {
  position: absolute;
  top: 0;
  left: -9999px;
  white-space: pre;
  pointer-events: none;
}
.ant-select-search--inline > i {
  float: right;
}
.ant-select-selection--multiple {
  min-height: 28px;
  cursor: text;
  padding-bottom: 3px;
  zoom: 1;
}
.ant-select-selection--multiple:before,
.ant-select-selection--multiple:after {
  content: " ";
  display: table;
}
.ant-select-selection--multiple:after {
  clear: both;
  visibility: hidden;
  font-size: 0;
  height: 0;
}
.ant-select-selection--multiple .ant-select-search--inline {
  width: auto;
  padding: 0;
  max-width: 100%;
}
.ant-select-selection--multiple .ant-select-search--inline .ant-select-search__field {
  max-width: 100%;
  width: 0.75em;
}
.ant-select-selection--multiple .ant-select-selection__rendered {
  margin-left: 5px;
  margin-bottom: -3px;
  height: auto;
}
.ant-select-selection--multiple > ul > li,
.ant-select-selection--multiple .ant-select-selection__rendered > ul > li {
  margin-top: 3px;
  height: 20px;
  line-height: 20px;
}
.ant-select-selection--multiple .ant-select-selection__choice {
  color: rgba(0, 0, 0, 0.65);
  background-color: #f3f3f3;
  border-radius: 4px;
  cursor: default;
  float: left;
  margin-right: 4px;
  max-width: 99%;
  position: relative;
  overflow: hidden;
  transition: padding 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
  padding: 0 20px 0 10px;
}
.ant-select-selection--multiple .ant-select-selection__choice__disabled {
  padding: 0 10px;
}
.ant-select-selection--multiple .ant-select-selection__choice__content {
  display: inline-block;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 100%;
  transition: margin 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
}
.ant-select-selection--multiple .ant-select-selection__choice__remove {
  font-style: normal;
  vertical-align: baseline;
  text-align: center;
  text-transform: none;
  line-height: 1;
  text-rendering: optimizeLegibility;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: rgba(0, 0, 0, 0.43);
  line-height: inherit;
  cursor: pointer;
  font-weight: bold;
  transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
  display: inline-block;
  font-size: 12px;
  font-size: 8px \9;
  transform: scale(0.66666667) rotate(0deg);
  /* IE6-IE8 */
  -ms-filter: "progid:DXImageTransform.Microsoft.Matrix(sizingMethod='auto expand', M11=1, M12=0, M21=0, M22=1)";
  zoom: 1;
  position: absolute;
  right: 4px;
  padding: 0 0 0 8px;
  top: 0;
}
.ant-select-selection--multiple .ant-select-selection__choice__remove:before {
  display: block;
  font-family: "anticon" !important;
}
:root .ant-select-selection--multiple .ant-select-selection__choice__remove {
  filter: none;
}
:root .ant-select-selection--multiple .ant-select-selection__choice__remove {
  font-size: 12px;
}
.ant-select-selection--multiple .ant-select-selection__choice__remove:hover {
  color: #404040;
}
.ant-select-selection--multiple .ant-select-selection__choice__remove:before {
  content: "\\e633";
}
.ant-select-selection--multiple .ant-select-selection__clear {
  top: 14px;
}
.ant-select-allow-clear .ant-select-selection--multiple .ant-select-selection__rendered {
  margin-right: 20px;
}
.ant-select-open .ant-select-arrow {
  -ms-filter: "progid:DXImageTransform.Microsoft.BasicImage(rotation=2)";
  -ms-transform: rotate(180deg);
}
.ant-select-open .ant-select-arrow:before {
  transform: rotate(180deg);
}
.ant-select-open .ant-select-selection {
  border-color: #49a9ee;
  outline: 0;
  box-shadow: 0 0 0 2px rgba(16, 142, 233, 0.2);
}
.ant-select-combobox .ant-select-arrow {
  display: none;
}
.ant-select-combobox .ant-select-search--inline {
  height: 100%;
  width: 100%;
  float: none;
}
.ant-select-combobox .ant-select-search__field__wrap {
  width: 100%;
  height: 100%;
}
.ant-select-combobox .ant-select-search__field {
  width: 100%;
  height: 100%;
  position: relative;
  z-index: 1;
  transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
  box-shadow: none;
}
.ant-select-combobox.ant-select-allow-clear .ant-select-selection:hover .ant-select-selection__rendered {
  margin-right: 20px;
}
.ant-select-dropdown {
  background-color: #fff;
  box-shadow: 0 1px 6px rgba(0, 0, 0, 0.2);
  border-radius: 4px;
  box-sizing: border-box;
  z-index: 1050;
  left: -9999px;
  top: -9999px;
  position: absolute;
  outline: none;
  overflow: hidden;
  font-size: 12px;
}
.ant-select-dropdown.slide-up-enter.slide-up-enter-active.ant-select-dropdown-placement-bottomLeft,
.ant-select-dropdown.slide-up-appear.slide-up-appear-active.ant-select-dropdown-placement-bottomLeft {
  animation-name: antSlideUpIn;
}
.ant-select-dropdown.slide-up-enter.slide-up-enter-active.ant-select-dropdown-placement-topLeft,
.ant-select-dropdown.slide-up-appear.slide-up-appear-active.ant-select-dropdown-placement-topLeft {
  animation-name: antSlideDownIn;
}
.ant-select-dropdown.slide-up-leave.slide-up-leave-active.ant-select-dropdown-placement-bottomLeft {
  animation-name: antSlideUpOut;
}
.ant-select-dropdown.slide-up-leave.slide-up-leave-active.ant-select-dropdown-placement-topLeft {
  animation-name: antSlideDownOut;
}
.ant-select-dropdown-hidden {
  display: none;
}
.ant-select-dropdown-menu {
  outline: none;
  margin-bottom: 0;
  padding-left: 0;
  list-style: none;
  max-height: 250px;
  overflow: auto;
}
.ant-select-dropdown-menu-item-group-list {
  margin: 0;
  padding: 0;
}
.ant-select-dropdown-menu-item-group-list > .ant-select-dropdown-menu-item {
  padding-left: 16px;
}
.ant-select-dropdown-menu-item-group-title {
  color: rgba(0, 0, 0, 0.43);
  line-height: 1.5;
  padding: 8px;
}
.ant-select-dropdown-menu-item {
  position: relative;
  display: block;
  padding: 7px 8px;
  font-weight: normal;
  color: rgba(0, 0, 0, 0.65);
  white-space: nowrap;
  cursor: pointer;
  overflow: hidden;
  transition: background 0.3s ease;
}
.ant-select-dropdown-menu-item:hover {
  background-color: #ecf6fd;
}
.ant-select-dropdown-menu-item-active {
  background-color: #ecf6fd;
}
.ant-select-dropdown-menu-item-disabled {
  color: rgba(0, 0, 0, 0.25);
  cursor: not-allowed;
}
.ant-select-dropdown-menu-item-disabled:hover {
  color: rgba(0, 0, 0, 0.25);
  background-color: #fff;
  cursor: not-allowed;
}
.ant-select-dropdown-menu-item-selected,
.ant-select-dropdown-menu-item-selected:hover {
  background-color: #f7f7f7;
  font-weight: bold;
  color: rgba(0, 0, 0, 0.65);
}
.ant-select-dropdown-menu-item-divider {
  height: 1px;
  margin: 1px 0;
  overflow: hidden;
  background-color: #e5e5e5;
  line-height: 0;
}
.ant-select-dropdown.ant-select-dropdown--multiple .ant-select-dropdown-menu-item:after {
  font-family: 'anticon';
  text-rendering: optimizeLegibility;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  content: "\\e632";
  color: transparent;
  display: inline-block;
  font-size: 12px;
  font-size: 10px \9;
  transform: scale(0.83333333) rotate(0deg);
  /* IE6-IE8 */
  -ms-filter: "progid:DXImageTransform.Microsoft.Matrix(sizingMethod='auto expand', M11=1, M12=0, M21=0, M22=1)";
  zoom: 1;
  transition: all 0.2s ease;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  right: 8px;
  font-weight: bold;
  text-shadow: 0 0.1px 0, 0.1px 0 0, 0 -0.1px 0, -0.1px 0;
}
:root .ant-select-dropdown.ant-select-dropdown--multiple .ant-select-dropdown-menu-item:after {
  filter: none;
}
:root .ant-select-dropdown.ant-select-dropdown--multiple .ant-select-dropdown-menu-item:after {
  font-size: 12px;
}
.ant-select-dropdown.ant-select-dropdown--multiple .ant-select-dropdown-menu-item:hover:after {
  color: #ddd;
}
.ant-select-dropdown.ant-select-dropdown--multiple .ant-select-dropdown-menu-item-disabled:after {
  display: none;
}
.ant-select-dropdown.ant-select-dropdown--multiple .ant-select-dropdown-menu-item-selected:after,
.ant-select-dropdown.ant-select-dropdown--multiple .ant-select-dropdown-menu-item-selected:hover:after {
  color: #108ee9;
  display: inline-block;
}
.ant-select-dropdown-container-open .ant-select-dropdown,
.ant-select-dropdown-open .ant-select-dropdown {
  display: block;
}
/***/
nz-select .ant-select {
  width: 100%;
}
.ant-select-dropdown {
  top: 100%;
  left: 0;
  position: relative;
  width: 100%;
  margin-top: 4px;
  margin-bottom: 4px;
}
.ant-select-dropdown.ant-select-dropdown-placement-topLeft {
  top: -100%;
  transform: translateY(-100%) !important;
}
.ant-select-dropdown-menu-item {
  line-height: 1.5;
}
.nz-overlay-pane {
  position: absolute;
}
.ant-select-page {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 12px;
  line-height: 2em;
  padding: 5px;
  user-select: none;
  text-align: center;
  background-color: #f9f9f9;
  border-top: 1px solid #ddd;
}
.ant-select-page-less,
.ant-select-page-next {
  color: #333;
  cursor: pointer;
}
.ant-select-page-disabled {
  color: #999!important;
  cursor: not-allowed !important;
}
.ant-select-search {
  background-color: #fff;
  padding: 4px;
  position: relative;
}
.ant-select-search-input {
  width: 100%;
  height: 30px;
  padding: 0 8px;
  border: 1px solid #eee;
}
.ant-select-search-input:focus {
  border-color: #49a9ee;
  outline: 0;
  box-shadow: 0 0 0 2px rgba(16, 142, 233, 0.2);
}
.ant-select-search-anticon {
  position: absolute;
  right: 13px;
  top: 11px;
  font-size: 15px;
  font-weight: 600;
  color: #999;
  cursor: pointer;
  height: 53%;
}
.ant-select-loading {
  position: absolute;
  left: 5px;
  top: -1px;
}
.nz-overlay-contain {
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  position: fixed;
  z-index: 1000;
}
.ant-select-dropdown {
  position: absolute!important;
  top: auto;
  left: auto;
}
/*定义滚动条高宽及背景 高宽分别对应横竖滚动条的尺寸*/
::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}
/*定义滚动条轨道 内阴影+圆角*/
::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
}
/*定义滑块 内阴影+圆角*/
::-webkit-scrollbar-thumb {
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  background-color: #d7d7d7;
}
@keyframes antCheckboxEffect {
  0% {
    transform: scale(1);
    opacity: 0.5;
  }
  100% {
    transform: scale(1.6);
    opacity: 0;
  }
}
.ant-checkbox {
  white-space: nowrap;
  cursor: pointer;
  outline: none;
  display: inline-block;
  line-height: 1;
  position: relative;
  vertical-align: text-bottom;
}
.ant-checkbox-wrapper:hover .ant-checkbox-inner,
.ant-checkbox:hover .ant-checkbox-inner,
.ant-checkbox-input:focus + .ant-checkbox-inner {
  border-color: #108ee9;
}
.ant-checkbox-checked:after {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border-radius: 2px;
  border: 1px solid #108ee9;
  content: '';
  animation: antCheckboxEffect 0.36s ease-in-out;
  animation-fill-mode: both;
  visibility: hidden;
}
.ant-checkbox:hover:after,
.ant-checkbox-wrapper:hover .ant-checkbox:after {
  visibility: visible;
}
.ant-checkbox-inner {
  position: relative;
  top: 0;
  left: 0;
  display: block;
  width: 14px;
  height: 14px;
  border: 1px solid #d9d9d9;
  border-radius: 2px;
  background-color: #fff;
  transition: all .3s;
}
.ant-checkbox-inner:after {
  transform: rotate(45deg) scale(0);
  position: absolute;
  left: 4px;
  top: 1px;
  display: table;
  width: 5px;
  height: 8px;
  border: 2px solid #fff;
  border-top: 0;
  border-left: 0;
  content: ' ';
  transition: all 0.1s cubic-bezier(0.71, -0.46, 0.88, 0.6);
}
.ant-checkbox-input {
  position: absolute;
  left: 0;
  z-index: 1;
  cursor: pointer;
  opacity: 0;
  filter: alpha(opacity=0);
  top: 0;
  bottom: 0;
  right: 0;
  width: 100%;
  height: 100%;
}
.ant-checkbox-indeterminate .ant-checkbox-inner:after {
  content: ' ';
  transform: scale(1);
  position: absolute;
  left: 2px;
  top: 5px;
  width: 8px;
  height: 1px;
}
.ant-checkbox-indeterminate.ant-checkbox-disabled .ant-checkbox-inner:after {
  border-color: rgba(0, 0, 0, 0.25);
}
.ant-checkbox-checked .ant-checkbox-inner:after {
  transform: rotate(45deg) scale(1);
  position: absolute;
  left: 4px;
  top: 1px;
  display: table;
  width: 5px;
  height: 8px;
  border: 2px solid #fff;
  border-top: 0;
  border-left: 0;
  content: ' ';
  transition: all 0.2s cubic-bezier(0.12, 0.4, 0.29, 1.46) 0.1s;
}
.ant-checkbox-checked .ant-checkbox-inner,
.ant-checkbox-indeterminate .ant-checkbox-inner {
  background-color: #108ee9;
  border-color: #108ee9;
}
.ant-checkbox-disabled {
  cursor: not-allowed;
}
.ant-checkbox-disabled.ant-checkbox-checked .ant-checkbox-inner:after {
  animation-name: none;
  border-color: rgba(0, 0, 0, 0.25);
}
.ant-checkbox-disabled .ant-checkbox-input {
  cursor: not-allowed;
}
.ant-checkbox-disabled .ant-checkbox-inner {
  border-color: #d9d9d9 !important;
  background-color: #f7f7f7;
}
.ant-checkbox-disabled .ant-checkbox-inner:after {
  animation-name: none;
  border-color: #f7f7f7;
}
.ant-checkbox-disabled + span {
  color: rgba(0, 0, 0, 0.25);
  cursor: not-allowed;
}
.ant-checkbox-wrapper {
  cursor: pointer;
  font-size: 12px;
  display: inline-block;
}
.ant-checkbox-wrapper:not(:last-child) {
  margin-right: 8px;
}
.ant-checkbox-wrapper + span,
.ant-checkbox + span {
  padding-left: 8px;
  padding-right: 8px;
}
.ant-checkbox-group {
  font-size: 12px;
}
.ant-checkbox-group-item {
  display: inline-block;
}
@media \0screen {
  .ant-checkbox-checked .ant-checkbox-inner:before,
  .ant-checkbox-checked .ant-checkbox-inner:after {
    font-family: 'anticon';
    text-rendering: optimizeLegibility;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    content: "\\e632";
    font-weight: bold;
    font-size: 8px;
    border: 0;
    color: #fff;
    left: 2px;
    top: 3px;
    position: absolute;
  }
}
.ant-tree-checkbox {
  white-space: nowrap;
  cursor: pointer;
  outline: none;
  display: inline-block;
  line-height: 1;
  position: relative;
  vertical-align: text-bottom;
}
.ant-tree-checkbox-wrapper:hover .ant-tree-checkbox-inner,
.ant-tree-checkbox:hover .ant-tree-checkbox-inner,
.ant-tree-checkbox-input:focus + .ant-tree-checkbox-inner {
  border-color: #108ee9;
}
.ant-tree-checkbox-checked:after {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border-radius: 2px;
  border: 1px solid #108ee9;
  content: '';
  animation: antCheckboxEffect 0.36s ease-in-out;
  animation-fill-mode: both;
  visibility: hidden;
}
.ant-tree-checkbox:hover:after,
.ant-tree-checkbox-wrapper:hover .ant-tree-checkbox:after {
  visibility: visible;
}
.ant-tree-checkbox-inner {
  position: relative;
  top: 0;
  left: 0;
  display: block;
  width: 14px;
  height: 14px;
  border: 1px solid #d9d9d9;
  border-radius: 2px;
  background-color: #fff;
  transition: all .3s;
}
.ant-tree-checkbox-inner:after {
  transform: rotate(45deg) scale(0);
  position: absolute;
  left: 4px;
  top: 1px;
  display: table;
  width: 5px;
  height: 8px;
  border: 2px solid #fff;
  border-top: 0;
  border-left: 0;
  content: ' ';
  transition: all 0.1s cubic-bezier(0.71, -0.46, 0.88, 0.6);
}
.ant-tree-checkbox-input {
  position: absolute;
  left: 0;
  z-index: 1;
  cursor: pointer;
  opacity: 0;
  filter: alpha(opacity=0);
  top: 0;
  bottom: 0;
  right: 0;
  width: 100%;
  height: 100%;
}
.ant-tree-checkbox-indeterminate .ant-tree-checkbox-inner:after {
  content: ' ';
  transform: scale(1);
  position: absolute;
  left: 2px;
  top: 5px;
  width: 8px;
  height: 1px;
}
.ant-tree-checkbox-indeterminate.ant-tree-checkbox-disabled .ant-tree-checkbox-inner:after {
  border-color: rgba(0, 0, 0, 0.25);
}
.ant-tree-checkbox-checked .ant-tree-checkbox-inner:after {
  transform: rotate(45deg) scale(1);
  position: absolute;
  left: 4px;
  top: 1px;
  display: table;
  width: 5px;
  height: 8px;
  border: 2px solid #fff;
  border-top: 0;
  border-left: 0;
  content: ' ';
  transition: all 0.2s cubic-bezier(0.12, 0.4, 0.29, 1.46) 0.1s;
}
.ant-tree-checkbox-checked .ant-tree-checkbox-inner,
.ant-tree-checkbox-indeterminate .ant-tree-checkbox-inner {
  background-color: #108ee9;
  border-color: #108ee9;
}
.ant-tree-checkbox-disabled {
  cursor: not-allowed;
}
.ant-tree-checkbox-disabled.ant-tree-checkbox-checked .ant-tree-checkbox-inner:after {
  animation-name: none;
  border-color: rgba(0, 0, 0, 0.25);
}
.ant-tree-checkbox-disabled .ant-tree-checkbox-input {
  cursor: not-allowed;
}
.ant-tree-checkbox-disabled .ant-tree-checkbox-inner {
  border-color: #d9d9d9 !important;
  background-color: #f7f7f7;
}
.ant-tree-checkbox-disabled .ant-tree-checkbox-inner:after {
  animation-name: none;
  border-color: #f7f7f7;
}
.ant-tree-checkbox-disabled + span {
  color: rgba(0, 0, 0, 0.25);
  cursor: not-allowed;
}
.ant-tree-checkbox-wrapper {
  cursor: pointer;
  font-size: 12px;
  display: inline-block;
}
.ant-tree-checkbox-wrapper:not(:last-child) {
  margin-right: 8px;
}
.ant-tree-checkbox-wrapper + span,
.ant-tree-checkbox + span {
  padding-left: 8px;
  padding-right: 8px;
}
.ant-tree-checkbox-group {
  font-size: 12px;
}
.ant-tree-checkbox-group-item {
  display: inline-block;
}
@media \0screen {
  .ant-tree-checkbox-checked .ant-tree-checkbox-inner:before,
  .ant-tree-checkbox-checked .ant-tree-checkbox-inner:after {
    font-family: 'anticon';
    text-rendering: optimizeLegibility;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    content: "\\e632";
    font-weight: bold;
    font-size: 8px;
    border: 0;
    color: #fff;
    left: 2px;
    top: 3px;
    position: absolute;
  }
}
.ant-tree {
  margin: 0;
  padding: 0;
  font-size: 12px;
}
.ant-tree li {
  padding: 4px 0;
  margin: 0;
  list-style: none;
  white-space: nowrap;
  outline: 0;
}
.ant-tree li span[draggable],
.ant-tree li span[draggable="true"] {
  user-select: none;
  border-top: 2px transparent solid;
  border-bottom: 2px transparent solid;
  margin-top: -2px;
  /* Required to make elements draggable in old WebKit */
  -khtml-user-drag: element;
  -webkit-user-drag: element;
}
.ant-tree li.drag-over > span[draggable] {
  background-color: #108ee9;
  color: white;
  opacity: 0.8;
}
.ant-tree li.drag-over-gap-top > span[draggable] {
  border-top-color: #108ee9;
}
.ant-tree li.drag-over-gap-bottom > span[draggable] {
  border-bottom-color: #108ee9;
}
.ant-tree li.filter-node > span {
  color: #f04134 !important;
  font-weight: 500 !important;
}
.ant-tree li ul {
  margin: 0;
  padding: 0 0 0 18px;
}
.ant-tree li .ant-tree-node-content-wrapper {
  display: inline-block;
  padding: 3px 5px;
  border-radius: 2px;
  margin: 0;
  cursor: pointer;
  text-decoration: none;
  vertical-align: top;
  color: rgba(0, 0, 0, 0.65);
  transition: all 0.3s ease;
}
.ant-tree li .ant-tree-node-content-wrapper:hover {
  background-color: #ecf6fd;
}
.ant-tree li .ant-tree-node-content-wrapper.ant-tree-node-selected {
  background-color: #d2eafb;
}
.ant-tree li span.ant-tree-checkbox {
  margin: 0 4px 0 2px;
  vertical-align: middle;
}
.ant-tree li span.ant-tree-switcher,
.ant-tree li span.ant-tree-iconEle {
  margin: 0;
  width: 24px;
  height: 24px;
  line-height: 24px;
  display: inline-block;
  vertical-align: middle;
  border: 0 none;
  cursor: pointer;
  outline: none;
  text-align: center;
}
.ant-tree li span.ant-tree-icon_loading:after {
  display: inline-block;
  font-family: 'anticon';
  text-rendering: optimizeLegibility;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  content: "\\e6ae";
  animation: loadingCircle 1s infinite linear;
  color: #108ee9;
}
.ant-tree li span.ant-tree-switcher.ant-tree-switcher-noop {
  cursor: default;
}
.ant-tree li span.ant-tree-switcher.ant-tree-switcher_open:after {
  font-size: 12px;
  font-size: 7px \9;
  transform: scale(0.58333333) rotate(0deg);
  /* IE6-IE8 */
  -ms-filter: "progid:DXImageTransform.Microsoft.Matrix(sizingMethod='auto expand', M11=1, M12=0, M21=0, M22=1)";
  zoom: 1;
  display: inline-block;
  font-family: 'anticon';
  text-rendering: optimizeLegibility;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  content: "\\e606";
  font-weight: bold;
  transition: transform .3s;
}
:root .ant-tree li span.ant-tree-switcher.ant-tree-switcher_open:after {
  filter: none;
}
:root .ant-tree li span.ant-tree-switcher.ant-tree-switcher_open:after {
  font-size: 12px;
}
.ant-tree li span.ant-tree-switcher.ant-tree-switcher_close {
  -ms-filter: "progid:DXImageTransform.Microsoft.BasicImage(rotation=3)";
}
.ant-tree li span.ant-tree-switcher.ant-tree-switcher_close:after {
  font-size: 12px;
  font-size: 7px \9;
  transform: scale(0.58333333) rotate(0deg);
  /* IE6-IE8 */
  -ms-filter: "progid:DXImageTransform.Microsoft.Matrix(sizingMethod='auto expand', M11=1, M12=0, M21=0, M22=1)";
  zoom: 1;
  display: inline-block;
  font-family: 'anticon';
  text-rendering: optimizeLegibility;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  content: "\\e606";
  font-weight: bold;
  transition: transform .3s;
}
:root .ant-tree li span.ant-tree-switcher.ant-tree-switcher_close:after {
  filter: none;
}
:root .ant-tree li span.ant-tree-switcher.ant-tree-switcher_close:after {
  font-size: 12px;
}
.ant-tree li span.ant-tree-switcher.ant-tree-switcher_close:after {
  transform: rotate(270deg) scale(0.59);
}
.ant-tree li:last-child > span.ant-tree-switcher:before,
.ant-tree li:last-child > span.ant-tree-iconEle:before {
  display: none;
}
.ant-tree > li:first-child {
  padding-top: 7px;
}
.ant-tree > li:last-child {
  padding-bottom: 7px;
}
.ant-tree-child-tree {
  display: none;
}
.ant-tree-child-tree-open {
  display: block;
}
li.ant-tree-treenode-disabled > span,
li.ant-tree-treenode-disabled > .ant-tree-node-content-wrapper,
li.ant-tree-treenode-disabled > .ant-tree-node-content-wrapper span,
li.ant-tree-treenode-disabled > span.ant-tree-switcher {
  color: rgba(0, 0, 0, 0.25);
  cursor: not-allowed;
}
li.ant-tree-treenode-disabled > .ant-tree-node-content-wrapper:hover {
  background: transparent;
}
.ant-tree-icon__open {
  margin-right: 2px;
  vertical-align: top;
}
.ant-tree-icon__close {
  margin-right: 2px;
  vertical-align: top;
}
.ant-tree.ant-tree-show-line li {
  position: relative;
}
.ant-tree.ant-tree-show-line li span.ant-tree-switcher {
  background: #fff;
  color: rgba(0, 0, 0, 0.65);
}
.ant-tree.ant-tree-show-line li span.ant-tree-switcher.ant-tree-switcher-noop:after {
  font-size: 12px;
  font-size: 12px \9;
  transform: scale(1) rotate(0deg);
  /* IE6-IE8 */
  -ms-filter: "progid:DXImageTransform.Microsoft.Matrix(sizingMethod='auto expand', M11=1, M12=0, M21=0, M22=1)";
  zoom: 1;
  display: inline-block;
  font-family: 'anticon';
  text-rendering: optimizeLegibility;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  content: "\\e664";
  vertical-align: baseline;
  font-weight: normal;
  transition: transform .3s;
}
:root .ant-tree.ant-tree-show-line li span.ant-tree-switcher.ant-tree-switcher-noop:after {
  filter: none;
}
:root .ant-tree.ant-tree-show-line li span.ant-tree-switcher.ant-tree-switcher-noop:after {
  font-size: 12px;
}
.ant-tree.ant-tree-show-line li span.ant-tree-switcher.ant-tree-switcher_open {
  color: rgba(0, 0, 0, 0.43);
}
.ant-tree.ant-tree-show-line li span.ant-tree-switcher.ant-tree-switcher_open:after {
  font-size: 12px;
  font-size: 12px \9;
  transform: scale(1) rotate(0deg);
  /* IE6-IE8 */
  -ms-filter: "progid:DXImageTransform.Microsoft.Matrix(sizingMethod='auto expand', M11=1, M12=0, M21=0, M22=1)";
  zoom: 1;
  display: inline-block;
  font-family: 'anticon';
  text-rendering: optimizeLegibility;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  content: "\\e621";
  vertical-align: baseline;
  font-weight: normal;
  transition: transform .3s;
}
:root .ant-tree.ant-tree-show-line li span.ant-tree-switcher.ant-tree-switcher_open:after {
  filter: none;
}
:root .ant-tree.ant-tree-show-line li span.ant-tree-switcher.ant-tree-switcher_open:after {
  font-size: 12px;
}
.ant-tree.ant-tree-show-line li span.ant-tree-switcher.ant-tree-switcher_close {
  color: rgba(0, 0, 0, 0.43);
}
.ant-tree.ant-tree-show-line li span.ant-tree-switcher.ant-tree-switcher_close:after {
  font-size: 12px;
  font-size: 12px \9;
  transform: scale(1) rotate(0deg);
  /* IE6-IE8 */
  -ms-filter: "progid:DXImageTransform.Microsoft.Matrix(sizingMethod='auto expand', M11=1, M12=0, M21=0, M22=1)";
  zoom: 1;
  display: inline-block;
  font-family: 'anticon';
  text-rendering: optimizeLegibility;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  content: "\\e645";
  vertical-align: baseline;
  font-weight: normal;
  transition: transform .3s;
}
:root .ant-tree.ant-tree-show-line li span.ant-tree-switcher.ant-tree-switcher_close:after {
  filter: none;
}
:root .ant-tree.ant-tree-show-line li span.ant-tree-switcher.ant-tree-switcher_close:after {
  font-size: 12px;
}
.ant-tree.ant-tree-show-line li:not(:last-child):before {
  content: ' ';
  width: 1px;
  border-left: 1px solid #d9d9d9;
  height: 100%;
  position: absolute;
  left: 12px;
  margin: 18px 0;
}
.ant-select-tree-checkbox {
  white-space: nowrap;
  cursor: pointer;
  outline: none;
  display: inline-block;
  line-height: 1;
  position: relative;
  vertical-align: text-bottom;
}
.ant-select-tree-checkbox-wrapper:hover .ant-select-tree-checkbox-inner,
.ant-select-tree-checkbox:hover .ant-select-tree-checkbox-inner,
.ant-select-tree-checkbox-input:focus + .ant-select-tree-checkbox-inner {
  border-color: #108ee9;
}
.ant-select-tree-checkbox-checked:after {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border-radius: 2px;
  border: 1px solid #108ee9;
  content: '';
  animation: antCheckboxEffect 0.36s ease-in-out;
  animation-fill-mode: both;
  visibility: hidden;
}
.ant-select-tree-checkbox:hover:after,
.ant-select-tree-checkbox-wrapper:hover .ant-select-tree-checkbox:after {
  visibility: visible;
}
.ant-select-tree-checkbox-inner {
  position: relative;
  top: 0;
  left: 0;
  display: block;
  width: 14px;
  height: 14px;
  border: 1px solid #d9d9d9;
  border-radius: 2px;
  background-color: #fff;
  transition: all .3s;
}
.ant-select-tree-checkbox-inner:after {
  transform: rotate(45deg) scale(0);
  position: absolute;
  left: 4px;
  top: 1px;
  display: table;
  width: 5px;
  height: 8px;
  border: 2px solid #fff;
  border-top: 0;
  border-left: 0;
  content: ' ';
  transition: all 0.1s cubic-bezier(0.71, -0.46, 0.88, 0.6);
}
.ant-select-tree-checkbox-input {
  position: absolute;
  left: 0;
  z-index: 1;
  cursor: pointer;
  opacity: 0;
  filter: alpha(opacity=0);
  top: 0;
  bottom: 0;
  right: 0;
  width: 100%;
  height: 100%;
}
.ant-select-tree-checkbox-indeterminate .ant-select-tree-checkbox-inner:after {
  content: ' ';
  transform: scale(1);
  position: absolute;
  left: 2px;
  top: 5px;
  width: 8px;
  height: 1px;
}
.ant-select-tree-checkbox-indeterminate.ant-select-tree-checkbox-disabled .ant-select-tree-checkbox-inner:after {
  border-color: rgba(0, 0, 0, 0.25);
}
.ant-select-tree-checkbox-checked .ant-select-tree-checkbox-inner:after {
  transform: rotate(45deg) scale(1);
  position: absolute;
  left: 4px;
  top: 1px;
  display: table;
  width: 5px;
  height: 8px;
  border: 2px solid #fff;
  border-top: 0;
  border-left: 0;
  content: ' ';
  transition: all 0.2s cubic-bezier(0.12, 0.4, 0.29, 1.46) 0.1s;
}
.ant-select-tree-checkbox-checked .ant-select-tree-checkbox-inner,
.ant-select-tree-checkbox-indeterminate .ant-select-tree-checkbox-inner {
  background-color: #108ee9;
  border-color: #108ee9;
}
.ant-select-tree-checkbox-disabled {
  cursor: not-allowed;
}
.ant-select-tree-checkbox-disabled.ant-select-tree-checkbox-checked .ant-select-tree-checkbox-inner:after {
  animation-name: none;
  border-color: rgba(0, 0, 0, 0.25);
}
.ant-select-tree-checkbox-disabled .ant-select-tree-checkbox-input {
  cursor: not-allowed;
}
.ant-select-tree-checkbox-disabled .ant-select-tree-checkbox-inner {
  border-color: #d9d9d9 !important;
  background-color: #f7f7f7;
}
.ant-select-tree-checkbox-disabled .ant-select-tree-checkbox-inner:after {
  animation-name: none;
  border-color: #f7f7f7;
}
.ant-select-tree-checkbox-disabled + span {
  color: rgba(0, 0, 0, 0.25);
  cursor: not-allowed;
}
.ant-select-tree-checkbox-wrapper {
  cursor: pointer;
  font-size: 12px;
  display: inline-block;
}
.ant-select-tree-checkbox-wrapper:not(:last-child) {
  margin-right: 8px;
}
.ant-select-tree-checkbox-wrapper + span,
.ant-select-tree-checkbox + span {
  padding-left: 8px;
  padding-right: 8px;
}
.ant-select-tree-checkbox-group {
  font-size: 12px;
}
.ant-select-tree-checkbox-group-item {
  display: inline-block;
}
@media \0screen {
  .ant-select-tree-checkbox-checked .ant-select-tree-checkbox-inner:before,
  .ant-select-tree-checkbox-checked .ant-select-tree-checkbox-inner:after {
    font-family: 'anticon';
    text-rendering: optimizeLegibility;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    content: "\\e632";
    font-weight: bold;
    font-size: 8px;
    border: 0;
    color: #fff;
    left: 2px;
    top: 3px;
    position: absolute;
  }
}
.ant-select-tree {
  margin: 0;
  padding: 0 4px;
  margin-top: -4px;
  font-size: 12px;
}
.ant-select-tree li {
  padding: 0;
  margin: 8px 0;
  list-style: none;
  white-space: nowrap;
  outline: 0;
}
.ant-select-tree li.filter-node > span {
  font-weight: 500;
}
.ant-select-tree li ul {
  margin: 0;
  padding: 0 0 0 18px;
}
.ant-select-tree li .ant-select-tree-node-content-wrapper {
  display: inline-block;
  padding: 3px 5px;
  border-radius: 2px;
  margin: 0;
  cursor: pointer;
  text-decoration: none;
  color: rgba(0, 0, 0, 0.65);
  transition: all .3s;
  width: calc(100% - 24px);
}
.ant-select-tree li .ant-select-tree-node-content-wrapper:hover {
  background-color: #ecf6fd;
}
.ant-select-tree li .ant-select-tree-node-content-wrapper.ant-select-tree-node-selected {
  background-color: #d2eafb;
}
.ant-select-tree li span.ant-select-tree-checkbox {
  margin: 0 4px 0 0;
}
.ant-select-tree li span.ant-select-tree-checkbox + .ant-select-tree-node-content-wrapper {
  width: calc(100% - 46px);
}
.ant-select-tree li span.ant-select-tree-switcher,
.ant-select-tree li span.ant-select-tree-iconEle {
  margin: 0;
  width: 24px;
  height: 24px;
  line-height: 22px;
  display: inline-block;
  vertical-align: middle;
  border: 0 none;
  cursor: pointer;
  outline: none;
  text-align: center;
}
.ant-select-tree li span.ant-select-tree-icon_loading:after {
  display: inline-block;
  font-family: 'anticon';
  text-rendering: optimizeLegibility;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  content: "\\e6ae";
  animation: loadingCircle 1s infinite linear;
  color: #108ee9;
}
.ant-select-tree li span.ant-select-tree-switcher.ant-select-tree-switcher-noop {
  cursor: auto;
}
.ant-select-tree li span.ant-select-tree-switcher.ant-select-tree-switcher_open:after {
  font-size: 12px;
  font-size: 7px \9;
  transform: scale(0.58333333) rotate(0deg);
  /* IE6-IE8 */
  -ms-filter: "progid:DXImageTransform.Microsoft.Matrix(sizingMethod='auto expand', M11=1, M12=0, M21=0, M22=1)";
  zoom: 1;
  display: inline-block;
  font-family: 'anticon';
  text-rendering: optimizeLegibility;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  content: "\\e606";
  font-weight: bold;
  transition: transform .3s;
}
:root .ant-select-tree li span.ant-select-tree-switcher.ant-select-tree-switcher_open:after {
  filter: none;
}
:root .ant-select-tree li span.ant-select-tree-switcher.ant-select-tree-switcher_open:after {
  font-size: 12px;
}
.ant-select-tree li span.ant-select-tree-switcher.ant-select-tree-switcher_close {
  -ms-filter: "progid:DXImageTransform.Microsoft.BasicImage(rotation=3)";
}
.ant-select-tree li span.ant-select-tree-switcher.ant-select-tree-switcher_close:after {
  font-size: 12px;
  font-size: 7px \9;
  transform: scale(0.58333333) rotate(0deg);
  /* IE6-IE8 */
  -ms-filter: "progid:DXImageTransform.Microsoft.Matrix(sizingMethod='auto expand', M11=1, M12=0, M21=0, M22=1)";
  zoom: 1;
  display: inline-block;
  font-family: 'anticon';
  text-rendering: optimizeLegibility;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  content: "\\e606";
  font-weight: bold;
  transition: transform .3s;
}
:root .ant-select-tree li span.ant-select-tree-switcher.ant-select-tree-switcher_close:after {
  filter: none;
}
:root .ant-select-tree li span.ant-select-tree-switcher.ant-select-tree-switcher_close:after {
  font-size: 12px;
}
.ant-select-tree li span.ant-select-tree-switcher.ant-select-tree-switcher_close:after {
  transform: rotate(270deg) scale(0.59);
}
.ant-select-tree-child-tree {
  display: none;
}
.ant-select-tree-child-tree-open {
  display: block;
}
li.ant-select-tree-treenode-disabled > span,
li.ant-select-tree-treenode-disabled > .ant-select-tree-node-content-wrapper,
li.ant-select-tree-treenode-disabled > .ant-select-tree-node-content-wrapper span,
li.ant-select-tree-treenode-disabled > span.ant-select-tree-switcher {
  color: rgba(0, 0, 0, 0.25);
  cursor: not-allowed;
}
li.ant-select-tree-treenode-disabled > .ant-select-tree-node-content-wrapper:hover {
  background: transparent;
}
.ant-select-tree-icon__open {
  margin-right: 2px;
  vertical-align: top;
}
.ant-select-tree-icon__close {
  margin-right: 2px;
  vertical-align: top;
}
.ant-select-tree-dropdown .ant-select-dropdown-search {
  display: block;
  padding: 4px;
}
.ant-select-tree-dropdown .ant-select-dropdown-search .ant-select-search__field__wrap {
  width: 100%;
}
.ant-select-tree-dropdown .ant-select-dropdown-search .ant-select-search__field {
  padding: 4px 7px;
  width: 100%;
  box-sizing: border-box;
  border: 1px solid #d9d9d9;
  border-radius: 4px;
  outline: none;
}
.ant-select-tree-dropdown .ant-select-dropdown-search.ant-select-search--hide {
  display: none;
}
.ant-select-tree-dropdown .ant-select-not-found {
  cursor: not-allowed;
  color: rgba(0, 0, 0, 0.25);
  padding: 7px 16px;
  display: block;
}
/*定义滚动条高宽及背景 高宽分别对应横竖滚动条的尺寸*/
::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}
/*定义滚动条轨道 内阴影+圆角*/
::-webkit-scrollbar-track {
  background-color: #f5f5f5;
}
/*定义滑块 内阴影+圆角*/
::-webkit-scrollbar-thumb {
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  background-color: #d7d7d7;
}
`]
})
export class TreeSelectComponent implements ControlValueAccessor, AfterContentChecked {

  public onTouchedCallback: () => void = noop;
  public showMoreLink = false;
  public moreLoaded = false;
  @Input() public disabled = false;
  @Input() public placeholder = '';
  @Input() public filterPlaceholder = '请输入关键词';
  @Input() public allowFilter = true;
  @Input() public maxHeight = 300;
  @Input() public width = 300;
  @Input() public className = '';
  private _isOpen = false;
  private onChangeCallback: (_: any) => void = noop;
  private haveFocus = false;
  private inputFocus = false;
  @Input()
  public set items(value: any[]) {
    this.svc.setItems(value);
  }

  @Input()
  public set idField(value: string) {
    this.svc.setConfiguration((opt) => opt.idProperty = value, true);
  }

  @Input()
  public set textField(value: string) {
    this.svc.setConfiguration((opt) => opt.textProperty = value, true);
  }

  @Input()
  public set allowParentSelection(value: boolean) {
    this.svc.setConfiguration((opt) => opt.allowParentSelection = value, true);
  }
  public get allowParentSelection(): boolean {
    return this.svc.Configuration.allowParentSelection;
  }

  @Input()
  public set childrenField(value: string) {
    this.svc.setConfiguration((opt) => opt.childProperty = value, true);
  }

  @Input()
  public set multiple(value: boolean) {
    this.svc.setConfiguration((opt) => opt.allowMultiple = value, true);
  }
  public get multiple(): boolean {
    return this.svc.Configuration.allowMultiple;
  }

  @Input()
  public set maxVisibleItemCount(value: number) {
    this.svc.setConfiguration((opt) => opt.maxVisibleItemCount = value, true);
  }
  public get maxVisibleItemCount(): number {
    return this.svc.Configuration.maxVisibleItemCount;
  }

  public get internalItems(): SelectableItem[] {
    return this.svc.getInternalItems() || [];
  }

  public get selection(): SelectableItem[] {
    this.showMoreLink = (
      this.maxVisibleItemCount > 0 &&
      ((this.svc.getInternalSelection().length - this.maxVisibleItemCount) > 0)
    );
    return this.svc.getInternalSelection();
  }

  public get filter(): string {
    return this.svc.Configuration.filter;
  }

  public set filter(value: string) {
    this.svc.setConfiguration((opt) => opt.filter = value, false);
    for (const item of this.internalItems) {
      this.ProcessMatchFilterTreeItem(item, this.svc.Configuration.filter);
    }
  }

  public constructor(
    private svc: SelectService,
    private defaultOpts: TreeSelectDefaultOptions,
    private eleRef: ElementRef
  ) {
    this.clickedOutside = this.clickedOutside.bind(this);

    this.svc.modelChanged$.subscribe((result) => {
      this.onChangeCallback(result);
    });
    this.maxVisibleItemCount = (defaultOpts.maxVisibleItemCount || 3);
    this.allowParentSelection = (
      (defaultOpts.allowParentSelection === undefined ||
        defaultOpts.allowParentSelection === null) ?
        true :
        defaultOpts.allowParentSelection
    );
    this.allowFilter = (
      (defaultOpts.allowFilter === undefined || defaultOpts.allowFilter === null) ?
        true :
        defaultOpts.allowFilter
    );
    this.filterPlaceholder = (defaultOpts.filterPlaceholder || '请输入关键词');
    this.idField = (defaultOpts.idField || 'id');
    this.textField = (defaultOpts.textField || 'id');
    this.childrenField = (defaultOpts.childrenField || '');
  }

  // tslint:disable-next-line:no-empty
  public keyUp($event: any): void { }

  public toggle($event: any): void {
    $event.preventDefault();
    this.haveFocus = true;
    this.svc.toggleOpen();
  }

  public removeItem($event: any, item: SelectableItem): void {
    $event.stopPropagation();
    this.svc.toggleItemSelection(item);
  }
  public clearAll($event: any): void {
    $event.stopPropagation();
    this.svc.setConfiguration(opt => opt.model = [], true);
  }
  public get isOpen(): boolean {
    return this.svc.Configuration.isOpen;
  }

  public clickedOutside($event: any): void {
    if (!this.inputFocus) {
      if (!this.haveFocus && this.isOpen || this.haveFocus && !this.isOpen) {
        this.onTouched();
      }
      this.haveFocus = false;
    }
  }
  _style(): any {
    var ro = this.eleRef.nativeElement.getBoundingClientRect();
    return {
      'width': ro.width + 'px',
      // 'left': ro.left + 'px',
      // 'top': ro.top + 'px',
      'max-height': this.maxHeight + 'px'
    }
  }

  // 鼠标移除组件时候隐藏下拉项
  @HostListener('blur')
  public onTouched(): void {
    this.svc.close();
    this.onTouchedCallback();
  }

  public setInputFocus(): void {
    this.inputFocus = true;
  }
  public setInputFocusOut(): void {
    this.inputFocus = false;
  }

  /**
   * Write a new value to the element.
   *
   * @memberof TreeSelectComponent
   */
  public writeValue(value: any): void {
    this.svc.setSelection(value);
  }

  /**
   * Set the function to be called when the control receives a change event.
   *
   */
  public registerOnChange(fn: any): void {
    this.onChangeCallback = fn;
  }

  /**
   * Set the function to be called when the control receives a touch event.
   *
   */
  public registerOnTouched(fn: any): void {
    this.onTouchedCallback = fn;
  }

  /**
   * This function is called when the control status changes to or from "DISABLED".
   * Depending on the value, it will enable or disable the appropriate DOM element.
   *
   */
  public setDisabledState?(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  /**
   * This finction is called when user click on show more link.
   *
   */
  public loadMore($event: any): void {
    $event.stopPropagation();
    this.moreLoaded = !this.moreLoaded;
  }

  ngAfterContentChecked(): void {
    this._style();
  }


  private ProcessMatchFilterTreeItem(tree: SelectableItem, filter: string): boolean {
    let result = false;
    if (tree && tree.children && tree.children.length > 0) {
      for (const child of tree.children) {
        result = this.ProcessMatchFilterTreeItem(child, filter) || result;
      }
    }
    tree.matchFilter = (tree.id.indexOf(filter) > -1 ||
      tree.text.indexOf(filter) > -1 ||
      tree.py.indexOf(filter) > -1 ||
      tree.firstPy.indexOf(filter) > -1 ||
      result);

    return tree.matchFilter;
  }

}
